import React from 'react';
import PageSeo from '../components/seo/PageSeo';
import { Link } from 'react-router-dom';
import {
  FaShieldHalved,
  FaCookieBite,
  FaChartLine,
  FaRectangleAd,
  FaUserShield,
  FaEnvelope,
  FaArrowUpRightFromSquare,
  FaDatabase,
  FaLink,
  FaClock,
} from 'react-icons/fa6';

import logo from '../img/logo.png';
import '../styles/InfoPage_3.css';

const PrivacyPolicy = () => {
  return (
    <main className="privacy-page">
      <PageSeo routePath="/privacy-policy" />

      <div className="privacy-container">
        {/* Hero */}
        <section className="privacy-hero">
          <div className="privacy-hero__content">
            <span className="privacy-eyebrow">
              Захист інформації користувачів
            </span>

            <h1>
              Політика
              <span>конфіденційності</span>
            </h1>

            <p>
              Ми поважаємо приватність відвідувачів BigSport і прагнемо
              прозоро пояснювати, які технології використовує сайт, які дані
              можуть оброблятися та як користувач може керувати своїми
              налаштуваннями.
            </p>

            <div className="privacy-hero__meta">
              <div>
                <FaClock />
                <span>
                  Останнє оновлення
                  <strong>23 липня 2026 року</strong>
                </span>
              </div>

              <div>
                <FaShieldHalved />
                <span>
                  Власник сайту
                  <strong>BigSport</strong>
                </span>
              </div>
            </div>
          </div>

          <div className="privacy-hero__visual">
            <div className="privacy-logo-card">
              <div className="privacy-logo-card__glow" />

              <div className="privacy-logo-card__shield">
                <FaShieldHalved />
              </div>

              <img src={logo} alt="Емблема BigSport" />

              <p>Прозорість. Безпека. Довіра.</p>
            </div>
          </div>
        </section>

        {/* Вступ */}
        <section className="privacy-section privacy-intro">
          <div className="privacy-section-heading">
            <span>Загальна інформація</span>
            <h2>Як BigSport працює з даними</h2>

            <p>
              Ця Політика конфіденційності поширюється на відвідувачів
              спортивного порталу BigSport і пояснює принципи використання
              cookie-файлів, аналітичних технологій, рекламних сервісів та
              інформації, яку користувач добровільно передає сайту.
            </p>
          </div>

          <div className="privacy-summary">
            <div className="privacy-summary__brand">
              <img src={logo} alt="BigSport" />
            </div>

            <div className="privacy-summary__content">
              <p>
                Під час відвідування сайту певна технічна інформація може
                передаватися автоматично через браузер, серверні журнали,
                cookie-файли та підключені сторонні сервіси.
              </p>

              <p>
                Ми використовуємо ці технології для стабільної роботи сайту,
                аналізу аудиторії, покращення контенту, безпеки та показу
                реклами.
              </p>

              <p>
                Використовуючи BigSport, ви підтверджуєте, що ознайомилися з
                цією Політикою. У випадках, передбачених законодавством,
                необов’язкові cookie-файли використовуються після отримання
                відповідної згоди.
              </p>
            </div>
          </div>
        </section>

        {/* Ключові розділи */}
        <section className="privacy-section">
          <div className="privacy-section-heading">
            <span>Основні положення</span>
            <h2>Яку інформацію можуть обробляти сервіси сайту</h2>

            <p>
              BigSport не продає персональні дані користувачів. Частина
              технічної інформації може оброблятися автоматично для роботи
              сайту та підключених сервісів.
            </p>
          </div>

          <div className="privacy-data-grid">
            <article className="privacy-data-card">
              <div className="privacy-data-card__icon">
                <FaDatabase />
              </div>

              <span>01</span>
              <h3>Технічна інформація</h3>

              <p>
                IP-адреса, тип браузера, операційна система, тип пристрою,
                мова браузера, дата й час відвідування, переглянуті сторінки та
                джерело переходу.
              </p>
            </article>

            <article className="privacy-data-card">
              <div className="privacy-data-card__icon">
                <FaCookieBite />
              </div>

              <span>02</span>
              <h3>Cookie-файли</h3>

              <p>
                Невеликі файли, які можуть зберігатися на пристрої для
                запам’ятовування налаштувань, роботи окремих функцій, аналітики
                та рекламних технологій.
              </p>
            </article>

            <article className="privacy-data-card">
              <div className="privacy-data-card__icon">
                <FaChartLine />
              </div>

              <span>03</span>
              <h3>Статистика використання</h3>

              <p>
                Інформація про відвідування сторінок, тривалість сеансів,
                взаємодію з матеріалами та інші узагальнені показники
                використання порталу.
              </p>
            </article>

            <article className="privacy-data-card">
              <div className="privacy-data-card__icon">
                <FaEnvelope />
              </div>

              <span>04</span>
              <h3>Дані зі звернень</h3>

              <p>
                Ім’я, електронна адреса та інша інформація, яку користувач
                добровільно надсилає редакції через електронну пошту або інші
                канали зв’язку.
              </p>
            </article>
          </div>
        </section>

        {/* Cookies */}
        <section className="privacy-dark-section">
          <div className="privacy-dark-section__visual">
            <div className="privacy-dark-section__icon">
              <FaCookieBite />
            </div>

            <img src={logo} alt="BigSport" />
          </div>

          <div className="privacy-dark-section__content">
            <span>Cookie-файли</span>
            <h2>Для чого сайт використовує cookies</h2>

            <p>
              Cookie-файли допомагають забезпечувати роботу сайту,
              запам’ятовувати налаштування, аналізувати відвідуваність і
              показувати релевантну рекламу.
            </p>

            <div className="privacy-cookie-list">
              <article>
                <strong>Необхідні</strong>
                <p>
                  Забезпечують базову роботу, навігацію, авторизацію та безпеку
                  сайту.
                </p>
              </article>

              <article>
                <strong>Функціональні</strong>
                <p>
                  Допомагають зберігати вибрані налаштування та покращувати
                  взаємодію з платформою.
                </p>
              </article>

              <article>
                <strong>Аналітичні</strong>
                <p>
                  Дозволяють оцінювати відвідуваність і вдосконалювати
                  структуру та контент сайту.
                </p>
              </article>

              <article>
                <strong>Рекламні</strong>
                <p>
                  Використовуються рекламними партнерами для показу,
                  вимірювання та персоналізації реклами.
                </p>
              </article>
            </div>
          </div>
        </section>

        {/* Аналітика */}
        <section className="privacy-section">
          <div className="privacy-section-heading">
            <span>Аналітичні технології</span>
            <h2>Статистика та покращення сайту</h2>
          </div>

          <div className="privacy-content-card">
            <div className="privacy-content-card__icon">
              <FaChartLine />
            </div>

            <div>
              <h3>Аналіз відвідуваності</h3>

              <p>
                BigSport може використовувати аналітичні сервіси для отримання
                узагальненої інформації про те, як відвідувачі користуються
                сайтом. Це допомагає визначати популярні розділи,
                вдосконалювати навігацію, швидкість завантаження та якість
                матеріалів.
              </p>

              <p>
                Постачальники таких сервісів можуть обробляти технічну
                інформацію відповідно до власних політик конфіденційності.
              </p>
            </div>
          </div>
        </section>

        {/* AdSense */}
        <section className="privacy-section">
          <div className="privacy-section-heading">
            <span>Реклама</span>
            <h2>Google AdSense і сторонні постачальники</h2>

            <p>
              На BigSport можуть розміщуватися рекламні оголошення Google
              AdSense та інших авторизованих рекламних партнерів.
            </p>
          </div>

          <div className="privacy-ads-card">
            <div className="privacy-ads-card__header">
              <div>
                <FaRectangleAd />
              </div>

              <div>
                <span>Рекламні технології</span>
                <h3>Як можуть використовуватися рекламні cookies</h3>
              </div>
            </div>

            <div className="privacy-ads-card__body">
              <p>
                Сторонні постачальники, включно з Google, можуть розміщувати та
                зчитувати cookie-файли у браузері користувача, а також
                використовувати вебмаяки, IP-адреси та інші технології для
                показу, вимірювання й персоналізації реклами.
              </p>

              <p>
                Використання рекламних cookie-файлів Google дає можливість
                Google та його партнерам показувати оголошення на основі
                відвідування користувачем BigSport та інших вебсайтів.
              </p>

              <p>
                Залежно від регіону, згоди користувача та вибраних налаштувань
                реклама може бути персоналізованою або неперсоналізованою.
              </p>

              <div className="privacy-external-links">
                <a
                  href="https://myadcenter.google.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Керувати рекламою в Google
                  <FaArrowUpRightFromSquare />
                </a>

                <a
                  href="https://policies.google.com/technologies/ads"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Як Google використовує рекламу
                  <FaArrowUpRightFromSquare />
                </a>

                <a
                  href="https://policies.google.com/technologies/cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Як Google використовує cookies
                  <FaArrowUpRightFromSquare />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Контентні розділи */}
        <section className="privacy-section">
          <div className="privacy-section-heading">
            <span>Умови обробки</span>
            <h2>Зберігання, захист і передача інформації</h2>
          </div>

          <div className="privacy-accordion-list">
            <article>
              <div className="privacy-accordion-list__number">01</div>

              <div>
                <h3>Зберігання інформації</h3>

                <p>
                  Інформація зберігається лише протягом періоду, необхідного
                  для відповідної мети обробки, роботи сервісів, забезпечення
                  безпеки або виконання юридичних обов’язків.
                </p>
              </div>
            </article>

            <article>
              <div className="privacy-accordion-list__number">02</div>

              <div>
                <h3>Захист даних</h3>

                <p>
                  Ми застосовуємо розумні організаційні та технічні заходи для
                  захисту інформації. Водночас жоден спосіб передавання чи
                  зберігання даних в інтернеті не може гарантувати абсолютну
                  безпеку.
                </p>
              </div>
            </article>

            <article>
              <div className="privacy-accordion-list__number">03</div>

              <div>
                <h3>Сторонні сервіси</h3>

                <p>
                  Дані можуть оброблятися постачальниками хостингу, аналітики,
                  реклами, авторизації та інших технічних сервісів, необхідних
                  для функціонування BigSport.
                </p>
              </div>
            </article>

            <article>
              <div className="privacy-accordion-list__number">04</div>

              <div>
                <h3>Посилання на інші сайти</h3>

                <p>
                  Матеріали BigSport можуть містити посилання на сторонні
                  ресурси. Ми не контролюємо їхні правила обробки даних і
                  рекомендуємо ознайомлюватися з політикою конфіденційності
                  кожного такого ресурсу.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* Права користувача */}
        <section className="privacy-rights">
          <div className="privacy-rights__heading">
            <span>Контроль інформації</span>
            <h2>Ваші права та можливості</h2>

            <p>
              Залежно від місця проживання та застосовного законодавства
              користувач може мати право отримати інформацію про обробку
              персональних даних, вимагати їх виправлення або видалення та
              відкликати раніше надану згоду.
            </p>
          </div>

          <div className="privacy-rights__grid">
            <article>
              <FaUserShield />
              <h3>Керування cookies</h3>
              <p>
                Змінюйте налаштування cookie-файлів через браузер або доступну
                на сайті панель згоди.
              </p>
            </article>

            <article>
              <FaRectangleAd />
              <h3>Налаштування реклами</h3>
              <p>
                Керуйте персоналізацією оголошень через Google My Ad Center.
              </p>
            </article>

            <article>
              <FaDatabase />
              <h3>Запит щодо даних</h3>
              <p>
                Зверніться до редакції для уточнення, виправлення або видалення
                добровільно наданих даних.
              </p>
            </article>

            <article>
              <FaLink />
              <h3>Сторонні ресурси</h3>
              <p>
                Переглядайте політики конфіденційності сервісів, посилання на
                які розміщені на сайті.
              </p>
            </article>
          </div>
        </section>

        {/* Діти */}
        <section className="privacy-section">
          <div className="privacy-content-card">
            <div className="privacy-content-card__icon">
              <FaUserShield />
            </div>

            <div>
              <h3>Конфіденційність дітей</h3>

              <p>
                BigSport не призначений для цілеспрямованого збору персональних
                даних дітей. Якщо батьки або законні представники вважають, що
                дитина передала нам персональні дані, вони можуть звернутися
                до редакції з проханням видалити таку інформацію.
              </p>
            </div>
          </div>
        </section>

        {/* Зміни */}
        <section className="privacy-section">
          <div className="privacy-content-card">
            <div className="privacy-content-card__icon">
              <FaClock />
            </div>

            <div>
              <h3>Зміни до Політики</h3>

              <p>
                Ми можемо періодично оновлювати цю Політику у зв’язку зі
                змінами функціональності сайту, підключених сервісів або
                законодавчих вимог.
              </p>

              <p>
                Актуальна редакція завжди публікується на цій сторінці із
                зазначенням дати останнього оновлення.
              </p>
            </div>
          </div>
        </section>

        {/* Контакт */}
        <section className="privacy-contact">
          <div>
            <span>Питання щодо конфіденційності</span>

            <h2>Потрібна додаткова інформація?</h2>

            <p>
              Напишіть редакції, якщо маєте запитання щодо цієї Політики,
              cookie-файлів або обробки інформації на BigSport.
            </p>
          </div>

          <div className="privacy-contact__actions">
            <a href="mailto:bigsport.com.ua@gmail.com">
              <FaEnvelope />
              bigsport.com.ua@gmail.com
            </a>

            <Link to="/contacts">
              Сторінка контактів
              <FaArrowUpRightFromSquare />
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
